<template>
  <v-container>
    <v-row dense>
          <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <div class="text-h4 font-weight-bold mb-4"><v-icon left color="green darken-2">mdi-map-legend</v-icon>Mi Finca</div>
      </v-col>

      <v-col cols="12">
        <div class="text-h7">Presiona el botón para agregar una finca nueva.</div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <!-- Si mostrarModal es falso, muestra pantalla normal desde el menu -->
        <v-btn
          v-if="!mostrarModal"
          @click="abrirFormularioFinca"
          depressed
          class="primary"
        >
          <v-icon left>mdi-plus</v-icon>
          Agregar una finca
        </v-btn>
        <!-- Si mostrarModal es TRUE, muestra el ModalFinca como cuadro flotante a traves de la pantalla solicitud-->
        <ModalFinca v-if="showModalFinca" @close="showModalFinca = false" />
      </v-col>

      <v-col cols="12" class="tt">
        <div class="text-h6"> <v-icon left color="green darken-1">mdi-leaf</v-icon>Ver mis fincas</div>
        <div class="text-h8">Toca una finca para ver o modificar sus detalles.</div>
      </v-col>

      <!-- Fila de espaciado -->
      <v-col cols="12" ></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->

      <!-- Mensaje si no hay fincas -->
      <v-col v-if="Object.keys(registros).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna finca
        </div>
      </v-col>
      <!-- listado de fincas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="registro in registros">
            <form-card
              :key="registro.id"
              :top-text="registro.nombre || 'Sin nombre...'"
              :middle-text="`Ruc : ${
                registro.ruc || '(no posee)'
              } , Número de registro : ${
                registro.num_registro || '(no posee)'
              }`"
              :bottom-right-text="producerDescription(registro.productor)"
              :sincronized="registro.sincronizado"
              @click="traerRegistroYNavegar(registro)"
            />
          </template>
        </v-list>
      </v-col>

      <!--       <v-col cols="12">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header class="text-subtitle-1 font-weight-bold"
              >Parcelas</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <parcelas></parcelas>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header class="text-subtitle-1 font-weight-bold"
              >Establecimientos (RUA)</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <establecimientos></establecimientos>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { producerDescription } from '@/utilidades'
import Establecimientos from './Establecimientos.vue'
import Parcelas from './Parcelas.vue'
import ModalFinca from '@/components/ModalFinca.vue'

export default {
  name: 'Fincas',
  components: {
    Establecimientos,
    Parcelas,
    ModalFinca,
  },
  computed: {
    ...mapState('registros', {
      registros: 'fincas',
    }),
    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  props: {
    mostrarModal: {
      type: Boolean,
      default: false,
    },
    registroId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      showModalFinca: false,
    }
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Fincas')
    if (this.mostrarModal) {
      this.showModalFinca = true
    }
  },

  methods: {
    producerDescription,

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getFinca', { id: registro.id })
      }
      this.$router.push(`/ru/finca/${registro.id}`)
    },

    abrirFormularioFinca() {
      if (this.mostrarModal) {
        this.showModalFinca = true // se abre el modal flotante desde la solicitud de beneficios
      } else {
        this.$router.push('/ru/finca') // ruta de finca
      }
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
